import React from 'react';
import styled from 'styled-components';

import {
  InputAdornment as MuiInputAdornment,
  InputBase as MuiInputBase,
  Badge as MuiBadge,
  Avatar as MuiAvatar,
  Typography as MuiTypography,
  Box as MuiBox,
  CircularProgress,
  useTheme,
} from '@mui/material';
import { SearchOutlined as SearchOutlinedIcon } from '@mui/icons-material';

import { PatientRow } from 'pages/PatientsPage/PatientsTable/PatientRow';

const BigSearch = styled(({ className, startIcon, ...props }) => (
  <MuiInputBase
    className={className}
    {...props}
    startAdornment={
      <MuiInputAdornment position="start">
        <SearchOutlinedIcon color="disabled" />
      </MuiInputAdornment>
    }
  />
))`
  && {
    background-color: ${(props) =>
      props.backgroundColor
        ? props.backgroundColor
        : props.theme.palette.common.white};
    border: 1px solid ${({theme}) => theme.palette.colors.gray200};
    border-radius: 10px;
    padding: 0 20px;
    height: 46px;
    width: 100%;
    display: flex;
  }
`;

const SmallSearch = styled(BigSearch)`
  && {
    background-color: ${(props) =>
      props.backgroundColor
        ? props.backgroundColor
        : props.theme.palette.common.white};
    border: 1px solid ${({theme}) => theme.palette.colors.gray200};
    height: 32px;
    padding: 0 10px;
  }
`;

const Search = (props) => {
  const { handleSelect, items, isHome, small, inputValue, loading, boxStyle } = props;
  const theme = useTheme()
  return (
    <MuiBox
      style={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        marginBottom: isHome && '20px',
        ...boxStyle
      }}
    >
      {small ? (
        <SmallSearch data-id="small-search" {...props} />
      ) : (
        <BigSearch data-id="big-search" {...props} />
      )}
      {items && inputValue && (
        <MuiBox
          style={{
            background: isHome ? theme.palette.colors.white : theme.palette.colors.gray100,
            zIndex: 1,
            width: '100%',
            borderRadius: 5,
            padding: '0 10px',
          }}
        >
          {loading ? (
            <p>Loading...</p>
          ) : (
            items?.map((option, idx) => {
              return (
                <>
                  {isHome ? (
                    <PatientRow
                      id={idx + 1}
                      key={idx}
                      patient={option}
                      isHome={isHome}
                    />
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        margin: '5px',
                        cursor: 'pointer',
                        justifyContent: 'flex-start',
                        borderRadius: 0,
                      }}
                      onClick={(e, value) => handleSelect(option.id)}
                      key={idx}
                    >
                      <MuiBadge variant="dot" style={{ marginRight: 16 }}>
                        <MuiAvatar src={option?.photoUrl} />
                      </MuiBadge>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <MuiTypography>
                          {option.firstName + '' + option.lastName}
                        </MuiTypography>
                      </div>
                    </div>
                  )}
                </>
              );
            })
          )}
        </MuiBox>
      )}
    </MuiBox>
  );
};
export default Search;
